import Account from "@/plugins/api/factories/Account";
import Auth from "@/plugins/api/factories/Auth";
import Settings from "@/plugins/api/factories/Settings";
import appBridge from "@/mixins/app-bridge";
// import axios from "axios";
import api from "@/plugins/api/EntryPoint";
import router from "@/router";
import axios from "axios";
import store from "@/store";

const PAYMENT_FLOW_SESSION_KEY = "paymentFlowInProgress";
const PAYMENT_FLOW_TTL_MS = 15 * 60 * 1000;

function isPaymentFlowInProgress() {
  const startedAt =
    Number(sessionStorage.getItem(PAYMENT_FLOW_SESSION_KEY)) ||
    Number(localStorage.getItem(PAYMENT_FLOW_SESSION_KEY));
  const expiresAt = Number(
    localStorage.getItem(`${PAYMENT_FLOW_SESSION_KEY}ExpiresAt`)
  );

  if (!startedAt) {
    return false;
  }

  if (expiresAt && Date.now() > expiresAt) {
    sessionStorage.removeItem(PAYMENT_FLOW_SESSION_KEY);
    localStorage.removeItem(PAYMENT_FLOW_SESSION_KEY);
    localStorage.removeItem(`${PAYMENT_FLOW_SESSION_KEY}ExpiresAt`);
    return false;
  }

  return Date.now() - startedAt < PAYMENT_FLOW_TTL_MS;
}

export const state = {
  sessionId: localStorage.getItem("sessionId") || null,
  hidden: false,
  guest: false,
  authLog: "",
  nativeData: null,
  authToken: localStorage.getItem("authToken") || null,
  userCredentials: (() => {
    try {
      return localStorage.getItem("userCredentials")
        ? JSON.parse(localStorage.getItem("userCredentials"))
        : null;
    } catch (e) {
      console.error("Ошибка при загрузке userCredentials:", e);
      localStorage.removeItem("userCredentials");
      return null;
    }
  })(), // Для сохранения логина/пароля
  appTheme: "dark",
  themeReady: false,
  accounts: (() => {
    try {
      return localStorage.getItem("accounts")
        ? JSON.parse(localStorage.getItem("accounts"))
        : {};
    } catch (e) {
      console.error("Ошибка при загрузке accounts:", e);
      localStorage.removeItem("accounts");
      return {};
    }
  })(),
  account: (() => {
    try {
      return localStorage.getItem("lastAccount")
        ? JSON.parse(localStorage.getItem("lastAccount"))
        : null;
    } catch (e) {
      console.error("Ошибка при загрузке lastAccount:", e);
      localStorage.removeItem("lastAccount");
      return null;
    }
  })(),
  balances: null,
  total: null,
  eic: null,
  accountNumber: null,
  phoneNumber: null,
  locale: process.env.VUE_APP_I18N_DEFAULT_LOCALE,
  requestedPage: null,
  advertisement: false,
  status: 0,
  status_sub: 0,
  share_status: 0,
  user_id: null,
  isPreloaded: false,
  phoneLoaded: false,
};

export const mutations = {
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_SESSION_ID(state, sessionId) {
    state.sessionId = sessionId;
    if (sessionId) {
      localStorage.setItem("sessionId", sessionId);
    } else {
      localStorage.removeItem("sessionId");
    }
  },
  WRITE_AUTH_LOG(state, logString) {
    state.authLog = state.authLog + ";" + logString;
  },
  SET_APP_THEME(state, appTheme) {
    document.body.classList.remove("app-theme-" + state.appTheme);
    state.appTheme = appTheme;
    state.themeReady = true;
    document.body.classList.add("app-theme-" + appTheme);

    Settings.setTheme(appTheme);
  },
  CHANGE_USER_THEME(state, theme) {
    Settings.setTheme(theme);
  },
  SET_REQUESTED_PAGE(state, requestedPage) {
    state.requestedPage = requestedPage;
  },
  SET_ACCOUNT_NUMBER(state, accountNumber) {
    state.accountNumber = accountNumber;
  },
  SET_NATIVE_DATA(state, nativeData) {
    state.nativeData = nativeData;
  },
  SET_AUTH_TOKEN(state, token) {
    state.authToken = token;
    if (token) {
      try {
        localStorage.setItem("authToken", token);
        console.log("Токен успешно сохранен в localStorage");
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } catch (e) {
        console.error("Ошибка при сохранении токена в localStorage:", e);
      }
    } else {
      localStorage.removeItem("authToken");
      delete axios.defaults.headers.common["Authorization"];
    }
  },
  SET_USER_STATUS(state, status) {
    state.status = status;
  },
  SET_USER_STATUS_SUB(state, status_sub) {
    state.status_sub = status_sub;
  },
  SET_USER_SHARE_STATUS(state, share_status) {
    state.share_status = share_status;
    console.log("SET_USER_SHARE_STATUS: " + JSON.stringify(state.share_status));
  },
  SET_USER_ID(state, user_id) {
    state.user_id = user_id;
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts;
    if (accounts) {
      try {
        localStorage.setItem("accounts", JSON.stringify(accounts));
        console.log("Счета успешно сохранены в localStorage");
      } catch (e) {
        console.error("Ошибка при сохранении счетов в localStorage:", e);
      }
    } else {
      localStorage.removeItem("accounts");
    }
  },
  SET_BALANCES(state, balances) {
    state.balances = balances;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_PHONE_NUMBER(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
  SET_LOCALE(state, locale) {
    let locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(",");
    if (locales.indexOf(locale) >= 0) {
      state.locale = locale;
    } else {
      state.locale = process.env.VUE_APP_I18N_DEFAULT_LOCALE;
    }
  },
  SET_ACCOUNT(state, account) {
    state.account = account;
    if (account) {
      try {
        localStorage.setItem("lastAccount", JSON.stringify(account));
        console.log(
          "Активный счет успешно сохранен в localStorage",
          account.ls
        );
      } catch (e) {
        console.error(
          "Ошибка при сохранении активного счета в localStorage:",
          e
        );
      }
    } else {
      localStorage.removeItem("lastAccount");
    }
  },
  SET_EIC(state, account) {
    state.eic = account;
  },
  SET_GUEST(state, guest) {
    state.guest = guest;
  },
  SET_HIDDEN(state, hidden) {
    state.hidden = hidden;
  },
  SET_ADVERTISEMENT(state, advertisement) {
    state.advertisement = advertisement;
  },
  SET_PHONE_LOADED(state, value) {
    state.phoneLoaded = value;
  },

  // Мутация для сохранения учетных данных
  SET_USER_CREDENTIALS(state, credentials) {
    state.userCredentials = credentials;
    if (credentials) {
      localStorage.setItem("userCredentials", JSON.stringify(credentials));
    } else {
      localStorage.removeItem("userCredentials");
    }
  },

  // Мутация для полного выхода
  LOGOUT(state) {
    state.authToken = null;
    state.userCredentials = null;
    state.accounts = {};
    state.account = null;
    localStorage.removeItem("authToken");
    localStorage.removeItem("userCredentials");
    localStorage.removeItem("accounts");
    localStorage.removeItem("lastAccount");
  },
};

export const getters = {
  nativeData(state) {
    return state.nativeData;
  },
};

export const actions = {
  // Экшен для автоматического входа - с обновлением счетов
  async tryAutoLogin({ commit, dispatch, state }) {
    console.log("--- Запуск tryAutoLogin - всегда обновляем счета ---");

    // Проверяем наличие сохраненных счетов и последнего активного счета
    const cachedAccounts = state.accounts;
    const lastAccount = state.account;
    const savedCredentials = state.userCredentials;

    // Если в localStorage есть сохраненные счета и последний счет, переходим на список счетов
    if (
      cachedAccounts &&
      Object.keys(cachedAccounts).length > 0 &&
      lastAccount
    ) {
      console.log(
        "[tryAutoLogin] Найдены сохраненные счета, но всё равно выполняю запрос на обновление"
      );

      // Просто вернем управление, обновление будет выполнено в AccountsListPage
      return;
    }

    // Если в localStorage есть сохраненные учетные данные, но нет счетов
    if (savedCredentials) {
      // При автоматическом входе сразу ставим статус loading
      commit("SET_STATUS", "loading");
      console.log(
        "[tryAutoLogin] Найдены сохраненные учетные данные, пытаюсь войти..."
      );
      try {
        // Проверяем наличие активного счета для передачи account_id
        let loginData = { ...savedCredentials };

        try {
          const lastAccountData = localStorage.getItem("lastAccount");
          if (lastAccountData) {
            const lastAccount = JSON.parse(lastAccountData);
            if (
              lastAccount &&
              (lastAccount.id || lastAccount.accountNumber || lastAccount.ls)
            ) {
              loginData.account_id =
                lastAccount.id || lastAccount.accountNumber || lastAccount.ls;
              console.log(
                "[tryAutoLogin] Добавлен account_id для входа:",
                loginData.account_id
              );
            }
          }
        } catch (parseError) {
          console.error(
            "[tryAutoLogin] Ошибка при получении lastAccount:",
            parseError
          );
        }

        await dispatch("loginWithBills", loginData);
        console.log("[tryAutoLogin] Вход по сохраненным данным успешен.");
      } catch (e) {
        console.error("[tryAutoLogin] Ошибка входа по сохраненным данным.", e);

        // Проверяем, есть ли у нас кешированные счета
        const cachedAccounts = localStorage.getItem("accounts");
        if (cachedAccounts) {
          try {
            // Если есть кешированные счета, используем их
            const accounts = JSON.parse(cachedAccounts);
            if (
              accounts &&
              (Array.isArray(accounts)
                ? accounts.length > 0
                : Object.keys(accounts).length > 0)
            ) {
              // Тихо используем кешированные данные без уведомления пользователя
              commit("SET_ACCOUNTS", accounts);
              commit("SET_STATUS", "success");
              // Переходим на список счетов
              if (!isPaymentFlowInProgress()) {
                router.push({ name: "AccountsListPage" }).catch(() => {});
              }
              return;
            }
          } catch (parseError) {
            console.error(
              "[tryAutoLogin] Ошибка при парсинге кешированных счетов:",
              parseError
            );
          }
        }

        // Если нет кешированных данных, тогда выходим
        commit("SET_STATUS", "error");
        dispatch("logout");
      }
      return;
    }

    console.log("[tryAutoLogin] Нет данных для автоматического входа.");
  },

  // Экшен для выхода
  logout({ commit }) {
    commit("LOGOUT");
    commit("SET_AUTH_TOKEN", null); // Удалит токен из localStorage
    commit("SET_USER_CREDENTIALS", null); // Удалит учетные данные

    // Также удаляем все остальные кеши
    localStorage.removeItem("force_reload");

    // Проверяем какие сейчас кеши в localStorage
    console.log("Состояние localStorage при выходе:", {
      authToken: Boolean(localStorage.getItem("authToken")),
      accounts: Boolean(localStorage.getItem("accounts")),
      lastAccount: Boolean(localStorage.getItem("lastAccount")),
      userCredentials: Boolean(localStorage.getItem("userCredentials")),
    });

    router.push({ name: "LoginPassword" });
  },

  async authenticate({ commit, dispatch, state }, authData) {
    commit("SET_NATIVE_DATA", authData);
    if (authData.agreement === true) {
      state.advertisement = true;
    }
    dispatch("newNativeData");
  },

  async newNativeData({ state, commit }) {
    // Проверяем, есть ли уже сохраненные счета и токен
    const hasSavedAccounts =
      localStorage.getItem("accounts") && localStorage.getItem("lastAccount");

    Account.nativeAuth(state.nativeData).then((response) => {
      console.log("Получен ответ от newNativeData (Apple/etc)", response.data);
      if (response.data && response.data.access_token) {
        commit("SET_AUTH_TOKEN", response.data.access_token);
        commit("SET_USER_STATUS", response.data.status);
        commit("SET_USER_ID", response.data.user_id);

        // Если уже есть счета, переходим к ним, иначе на вход
        if (hasSavedAccounts) {
          console.log(
            "Найдены сохраненные счета, переходим на AccountsListPage"
          );
          // Проверяем текущий маршрут
          const currentRoute = router.currentRoute.name;
          console.log(`Текущий маршрут: ${currentRoute}`);

          if (
            !isPaymentFlowInProgress() &&
            currentRoute !== "AccountsListPage" &&
            currentRoute !== "Home"
          ) {
            console.log(`Переходим с ${currentRoute} на AccountsListPage`);
            try {
              router.push({ name: "AccountsListPage" }).catch((err) => {
                // Игнорируем ошибки дублирования навигации
                if (err.name !== "NavigationDuplicated") {
                  console.error("Ошибка навигации:", err);
                }
              });
            } catch (e) {
              console.error("Ошибка при переходе:", e);
            }
          } else {
            console.log(
              `Уже находимся на ${currentRoute}, переход не требуется`
            );
          }
        } else {
          console.log(
            "Нативная авторизация успешна, перенаправляю на LoginPassword..."
          );
          if (router.currentRoute.name !== "LoginPassword") {
            router.push({ name: "LoginPassword" }).catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                console.error("Ошибка навигации:", err);
              }
            });
          }
        }
      } else {
        console.error("Ошибка нативной авторизации, нет токена.");
      }
    });
  },

  async storeGuest({ state }, callBackFn) {
    Account.guestMode(state.guest, (res) => {
      callBackFn(res);
    });
  },
  async getGuest({ commit }) {
    await Account.getGuestMode((response) => {
      commit("SET_GUEST", response.guest);
    });
  },
  async setupUserSettings({ dispatch, commit, state }) {
    await Settings.getLanguage(async (lang) => {
      let selectedLocale;
      if (lang.language === null) {
        await Settings.putLanguage(state.nativeData.lang);
        selectedLocale = state.nativeData.lang;
      } else {
        selectedLocale = lang.language;
      }
      commit("SET_LOCALE", selectedLocale);
      commit("Settings/UPDATE_LANGUAGE", selectedLocale, { root: true });
    });
    await Auth.getPhoneNumber((response) => {
      console.log(JSON.stringify("getPhoneNumber: " + response.phone));
      commit("SET_PHONE_NUMBER", response.phone);
      commit("SET_PHONE_LOADED", true);
      this.phoneLoaded = true;
    });
    dispatch("getAndSetupTheme");
  },
  async setUserPhone({ state, commit }) {
    console.log("TRY TO SET PHONE");
    if (state.authToken !== null && state.authToken !== undefined) {
      await Auth.getPhoneNumber((response) => {
        console.log("SET PHONE: " + response.phone);
        commit("SET_PHONE_NUMBER", response.phone);
        window.Tawk_API.setAttributes({
          phone: response.phone,
          link: "https://support.billing.city/user/" + response.id,
        });
      });
    }
  },
  async getAndSetupTheme({ commit, state }, theme) {
    await Settings.getTheme((res) => {
      state.themeReady = false;
      const themeToSetup = res.theme ? res.theme : theme ? theme : "dark";
      commit("SET_APP_THEME", themeToSetup);
      appBridge.methods.nativeSendEvent("setThemeMode", themeToSetup);
    });
  },
  async refreshToken({ commit }) {
    return Account.refreshToken((response) => {
      commit("SET_AUTH_TOKEN", response.access_token);
    });
  },
  async importAccounts() {
    return Account.importAccounts((res) => {
      return res.mode;
    });
  },

  fetchAndScrapeAccountDetails({ commit, state }, { accountId } = {}) {
    // Используем либо явно переданный accountId, либо текущий счет
    const ls = accountId || (state.account && state.account.ls);
    const cacheKey = `accountDetails_${ls}`;
    const MIN_SKELETON_TIME = 3000; // Минимальное время показа скелетона в мс (3 секунды)
    const startTime = Date.now();

    // Ставим статус загрузки до любых операций
    commit("SET_STATUS", "loading");

    // 1. Загружаем данные из кэша (localStorage) и сразу показываем их
    let cachedData = null;
    const cachedAccount = localStorage.getItem(cacheKey);

    if (cachedAccount) {
      try {
        cachedData = JSON.parse(cachedAccount);
        // Устанавливаем данные из кэша
        commit("SET_ACCOUNT", cachedData);

        // Если есть кэш, мы можем сразу показать данные, даже если еще загружаем новые
        console.log("Используем кэшированные данные:", cachedData);

        // Показываем успех загрузки сразу, чтобы сразу был доступный интерфейс
        commit("SET_STATUS", "success");
      } catch (e) {
        console.error("Ошибка парсинга кэша данных о счете:", e);
        // В случае ошибки показываем индикатор загрузки
        commit("SET_STATUS", "loading");
      }
    } else {
      console.log("Кэш для этого счета не найден:", cacheKey);
    }

    // 2. В любом случае, запросить свежие данные в фоне
    return new Promise((resolve, reject) => {
      if (!state.userCredentials) {
        console.error("Нет учетных данных для скрейпинга.");
        commit("SET_STATUS", "error");
        return reject("No credentials");
      }

      // Получаем корректный account_id из разных возможных источников
      const account_id =
        accountId ||
        (state.account &&
          (state.account.id ||
            state.account.accountNumber ||
            state.account.ls));

      // Логируем передачу account_id
      console.log(
        "Передаём account_id в метод scrapeAccountDetails:",
        account_id
      );

      // Создаём параметры запроса с обязательным account_id
      const params = {
        ...state.userCredentials,
        account_id: account_id,
      };

      // Информационный лог для отладки
      console.log(
        "Параметры запроса в scrapeAccountDetails:",
        JSON.stringify(params)
      );

      Auth.scrapeAccountDetails(
        params,
        (response) => {
          if (response && response.status === "success") {
            const formattedAccount = {
              ls: response.id,
              fio: response.fio,
              balance: parseFloat(response.debt) || 0,
              city: response.address,
              streetType: "",
              streetName: "",
              building: "",
              appartment: "",
            };

            // 3. Обновить состояние и сохранить свежие данные в кеш
            commit("SET_ACCOUNT", formattedAccount);
            localStorage.setItem(cacheKey, JSON.stringify(formattedAccount));

            // Если был кэш, то мы уже показали успех, просто обновляем данные
            if (cachedData) {
              commit("SET_ACCOUNT", formattedAccount);
              console.log("Данные счета успешно обновлены с сервера");
              resolve(formattedAccount);
            }
            // Если кэша не было, показываем минимальный скелетон
            else {
              // Проверяем, прошло ли минимальное время отображения скелетона
              const elapsedTime = Date.now() - startTime;
              const remainingTime = Math.max(
                0,
                MIN_SKELETON_TIME - elapsedTime
              );

              if (remainingTime > 0) {
                setTimeout(() => {
                  commit("SET_STATUS", "success"); // Сбрасываем загрузку после задержки
                  resolve(formattedAccount);
                }, remainingTime);
              } else {
                commit("SET_STATUS", "success"); // Сбрасываем загрузку сразу
                resolve(formattedAccount);
              }
            }
          } else {
            console.error(
              "Не удалось получить детали счета через скрейпинг",
              response
            );

            // Если у нас есть кэш, не показываем ошибку
            if (cachedData) {
              console.log(
                "Ошибка при обновлении данных, но показываем кэшированные данные:",
                response
              );

              // Просто возвращаем кэшированные данные
              resolve(cachedData);
            }
            // Иначе показываем ошибку
            else {
              // Также соблюдаем минимальное время отображения скелетона и при ошибке
              const elapsedTime = Date.now() - startTime;
              const remainingTime = Math.max(
                0,
                MIN_SKELETON_TIME - elapsedTime
              );

              if (remainingTime > 0) {
                setTimeout(() => {
                  commit("SET_STATUS", "error");
                  reject(response);
                }, remainingTime);
              } else {
                commit("SET_STATUS", "error");
                reject(response);
              }
            }
          }
        },
        state.sessionId
      );
    });
  },

  async loginWithBills(
    { commit, dispatch },
    { username, password, account_id }
  ) {
    // Устанавливаем флаг нового входа, чтобы не делать повторный запрос на странице списка счетов
    sessionStorage.setItem("freshLogin", "true");

    // Удаляем флаг через 30 секунд, чтобы не блокировать все будущие запросы
    setTimeout(() => {
      sessionStorage.removeItem("freshLogin");
      console.log("Сбросил флаг freshLogin через 30 секунд");
    }, 30000);

    const MAX_RETRIES = 3;
    const RETRY_DELAY = 1000; // 1 секунда

    // Устанавливаем статус загрузки при входе
    commit("SET_STATUS", "loading");

    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      try {
        console.log(`Попытка входа #${attempt}...`, {
          username,
          account_id: account_id || "не указан",
        });

        // Создаём объект параметров для запроса
        const loginParams = { username, password };

        // Если есть account_id, добавляем его в запрос
        if (account_id) {
          loginParams.account_id = account_id;
          console.log("Добавлен account_id в запрос loginBills:", account_id);
        }

        const response = await Account.loginBills(loginParams);
        console.log(`Ответ от сервера (попытка #${attempt}):`, response);

        // Проверяем на ошибку "Відсутні рахунки для цього користувача"
        // Это означает, что авторизация успешна, но у пользователя нет счетов
        if (
          response &&
          response.status === "error" &&
          response.message &&
          response.message.includes("Відсутні рахунки")
        ) {
          console.log("Пользователь авторизован успешно, но у него нет счетов");

          if (response.session_id) {
            commit("SET_SESSION_ID", response.session_id);
          }

          // Сохраняем учетные данные в localStorage
          const credentialsToStore = { username, password };
          if (account_id) {
            credentialsToStore.account_id = account_id;
          }

          commit("SET_USER_CREDENTIALS", credentialsToStore);
          commit("SET_ACCOUNTS", []); // Пустой массив счетов
          commit("SET_GUEST", false);
          commit("SET_NATIVE_DATA", {
            google_id_token: "",
            apple_user_id: "",
            agreement: true,
          });

          // Возвращаем ответ - LoginPassword.vue перенаправит на AddAccount
          return response;
        }

        // Проверяем на другие ошибки (неверный логин/пароль и т.д.)
        // Если это ошибка авторизации - сразу прекращаем попытки
        if (response && response.status === "error") {
          console.log("Ошибка авторизации:", response.message);
          throw response; // Выбрасываем ошибку, чтобы прекратить попытки
        }

        if (response && response.status === "success" && response.bills) {
          if (response.session_id) {
            commit("SET_SESSION_ID", response.session_id);
          }
          // Если счета есть ИЛИ это последняя попытка, обрабатываем ответ
          if (response.bills.length > 0 || attempt === MAX_RETRIES) {
            // Сохраняем также и account_id, если он был передан
            const credentialsToStore = { username, password };
            if (account_id) {
              credentialsToStore.account_id = account_id;
            }

            commit("SET_USER_CREDENTIALS", credentialsToStore);
            commit("SET_ACCOUNTS", response.bills);
            commit("SET_GUEST", false);
            commit("SET_NATIVE_DATA", {
              google_id_token: "",
              apple_user_id: "",
              agreement: true,
            });

            await dispatch("afterLogin", response.bills);
            return response; // Выходим из цикла и функции
          }
        }

        // Если счета не пришли, но это не последняя попытка, ждем и пробуем снова
        console.warn(`Попытка #${attempt} не вернула счетов, пробую снова...`);
        await new Promise((res) => setTimeout(res, RETRY_DELAY));
      } catch (e) {
        console.error(
          `Критическая ошибка в loginWithBills (попытка #${attempt}):`,
          e
        );
        // При критической ошибке (не ответа сервера, а сбоя) прекращаем попытки
        throw e;
      }
    }

    // Если все попытки не увенчались успехом
    console.error("Не удалось получить счета после нескольких попыток.");
    throw new Error("Не удалось получить счета после нескольких попыток.");
  },

  async afterLogin({ commit, state }, accounts) {
    console.log("[afterLogin] Запущен. Проверяем счета...");
    console.log("[afterLogin] Полученные счета:", accounts);

    // Сохраняем счета в локальное хранилище
    commit("SET_ACCOUNTS", accounts);
    if (isPaymentFlowInProgress()) {
      return;
    }

    if (accounts && accounts.length > 0) {
      console.log(
        "[afterLogin] Счета есть. Перенаправление на AccountsListPage."
      );

      // Если был сохранен последний активный счет
      if (state.account) {
        // Проверяем, существует ли сохраненный счет в текущем списке
        const accountExists = accounts.some(
          (acc) =>
            (acc.id && acc.id === state.account.id) ||
            (acc.accountNumber &&
              acc.accountNumber === state.account.accountNumber)
        );

        if (accountExists) {
          console.log(
            "[afterLogin] Найден сохраненный активный счет. Перенаправляю на Home."
          );
          router.replace({ name: "Home" });
          return;
        }
      }

      router.replace({ name: "AccountsListPage" });
    } else {
      console.log("[afterLogin] Счетов нет. Перенаправление на AddAccount.");
      router.replace({ name: "AddAccount" });
    }
  },
  async getUserAccounts({ commit, state }) {
    return Account.getAccounts(
      (response) => {
        return commit("SET_ACCOUNTS", response);
      },
      state.userCredentials,
      state.sessionId
    );
  },
  getUserAccount({ commit }, account) {
    return Account.getAccount(account, (response) => {
      console.log("GET USER ACCOUNT CHECK: " + JSON.stringify(response));
      commit("SET_ACCOUNT", response);
      commit("SET_EIC", response);
      commit("Payment/UPDATE_AMOUNT", response.balance, { root: true });
      commit("IndicationsHistory/SET_TARIFF", response.tariff, { root: true });

      // Сохраняем только данные счета, но не переходим на его страницу автоматически
      // Справка: переход на Home приводит к проблеме, что при повторном входе не показывается список счетов
      // Поскольку это перенаправление было добавлено как отдельный комментарий,
      // мы предполагаем, что в исходном коде оно не было необходимо
      // router.push({
      //   name: "Home",
      //   params: { clearStack: true },
      // });
    });
  },
  getUserBalances(ctx, data) {
    store.commit("Api/showLoader");
    ctx.commit("SET_TOTAL", null);
    return axios(`https://proc.billing.city/api/get-balance/${data.ls}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let total = 0;
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].service_name === "Електропостачання") {
            response.data.splice(i, 1);
          }
        }
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].company_name.includes("Нафтогаз") === true) {
            store.commit(
              "Payment/SET_GAS_LS",
              response.data[i].service_account
            );
          }
          response.data[i].checked = false;
          if (response.data[i].balance > 0) {
            total += response.data[i].balance;
            response.data[i].checked = true;
          }
        }
        console.log(JSON.stringify(response.data));
        ctx.commit("SET_TOTAL", total.toFixed(2));
        ctx.commit("SET_BALANCES", response.data);
        store.commit("Api/hideLoader");
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updateUserBalances(ctx, data) {
    ctx.commit("SET_TOTAL", null);
    store.commit("Api/showMessage");
    store.commit("Api/showLoader");
    return axios(`https://proc.billing.city/api/get-actual/${data.ls}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let total = 0;
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].service_name === "Електропостачання") {
            response.data.splice(i, 1);
          }
        }
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].company_name.includes("Нафтогаз") === true) {
            store.commit(
              "Payment/SET_GAS_LS",
              response.data[i].service_account
            );
          }
          response.data[i].checked = false;
          if (response.data[i].balance > 0) {
            total += response.data[i].balance;
            response.data[i].checked = true;
          }
        }
        console.log(JSON.stringify(response.data));
        ctx.commit("SET_TOTAL", total.toFixed(2));
        ctx.commit("SET_BALANCES", response.data);
        store.commit("Api/hideLoader");
        store.commit("Api/hideMessage");
      })
      .catch((error) => {
        console.log(error);
      });
  },
  storeNewAcont({ state }, callBackFn) {
    Account.storeAccount(state.accountNumber, (res) => {
      console.log(JSON.stringify(res));
      callBackFn(res);
    });
  },

  async newGoogleAuth({ commit, state }) {
    console.log("Запущена корректная newGoogleAuth");

    // Проверяем, есть ли уже сохраненные счета и токен
    const hasSavedAccounts =
      localStorage.getItem("accounts") && localStorage.getItem("lastAccount");

    try {
      const response = await Account.googleAuth(state.nativeData);
      console.log("Ответ от Account.googleAuth:", response);

      if (response && response.data && response.data.access_token) {
        commit("SET_AUTH_TOKEN", response.data.access_token);
        commit("SET_USER_STATUS", response.data.status);
        commit("SET_USER_ID", response.data.user_id);

        // Если уже есть счета, переходим к ним, иначе на вход
        if (hasSavedAccounts) {
          console.log(
            "Найдены сохраненные счета, переходим на AccountsListPage"
          );
          // Проверяем текущий маршрут
          const currentRoute = router.currentRoute.name;
          console.log(`Текущий маршрут в newGoogleAuth: ${currentRoute}`);

          if (
            !isPaymentFlowInProgress() &&
            currentRoute !== "AccountsListPage" &&
            currentRoute !== "Home"
          ) {
            console.log(`Переходим с ${currentRoute} на AccountsListPage`);
            try {
              router.push({ name: "AccountsListPage" }).catch((err) => {
                // Игнорируем ошибки дублирования навигации
                if (err.name !== "NavigationDuplicated") {
                  console.error("Ошибка навигации в newGoogleAuth:", err);
                }
              });
            } catch (e) {
              console.error("Ошибка при переходе в newGoogleAuth:", e);
            }
          } else {
            console.log(
              `Уже находимся на ${currentRoute}, переход не требуется`
            );
          }
        } else {
          console.log(
            "Авторизация Google успешна, перенаправляю на LoginPassword..."
          );
          if (router.currentRoute.name !== "LoginPassword") {
            router.push({ name: "LoginPassword" }).catch((err) => {
              if (err.name !== "NavigationDuplicated") {
                console.error(
                  "Ошибка навигации при переходе на LoginPassword:",
                  err
                );
              }
            });
          }
        }
      } else {
        console.warn("Ответ от Google Auth не содержит токен", response);
        // Только если нет счетов, переходим на вход
        if (!hasSavedAccounts) {
          router.replace({ name: "LoginPassword" });
        }
      }
    } catch (error) {
      console.error("Ошибка в newGoogleAuth:", error);
      // Только если нет счетов, переходим на вход
      if (!hasSavedAccounts) {
        router.replace({ name: "LoginPassword" });
      }
    }
  },
  deleteUserAccount({ dispatch }, accountNumber) {
    return Account.deleteAccountByNumber(accountNumber, () => {
      dispatch("getUserAccounts");
    });
  },
  deleteUser(callBackFn) {
    return Account.deleteUser((res) => {
      callBackFn(res);
    }).then(() => {
      this.$forceUpdate();
    });
  },
  getUserLanguage({ commit }) {
    return Settings.getLanguage((response) => {
      return commit("SET_LOCALE", response);
    });
  },
  guestMode(guest, cb) {
    return api.put("settings/set-guest", { guest: guest }, cb);
  },
  getGuestMode(callBackFn) {
    return api.get("settings/guest", callBackFn);
  },
  async getSubscriptionStatus({ commit }) {
    await Account.getSubscriptionStatus((response) => {
      // ✅ Исправлено: Используем только SET_USER_STATUS_SUB
      if (response.status === 0) {
        commit("SET_USER_STATUS_SUB", 0);
      } else {
        commit("SET_USER_STATUS_SUB", 1);
      }
      // ❗️ Больше не перезаписываем основной статус `state.status`
      localStorage.setItem("user_status", response.status);
    });
  },
};
